import useProperty from "hooks/useProperty";

import { EntityKind } from "models/entityKind";

import { splitUnitFromTitle } from "../PanelField";
import { CellUnit, MISSING_VALUE, TableCell } from "../styles";

/**
 * A table value with the unit from its catalogue title. The caller decides
 * what counts as missing, so each table keeps its own reading of the raw value.
 */
export function PropertyTableCell({
  propertyName,
  value
}: {
  propertyName: string;
  value: Maybe<string>;
}): JSX.Element {
  const property = useProperty(propertyName, false, "", EntityKind.Well);
  const { unit } = splitUnitFromTitle(property?.title);

  return (
    <TableCell $missing={!value} title={property?.partialContextTitle}>
      {value ?? MISSING_VALUE}
      {value && unit && <CellUnit> {unit}</CellUnit>}
    </TableCell>
  );
}
